/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataImportStatusEnum } from './DataImportStatusEnum';
import {
    DataImportStatusEnumFromJSON,
    DataImportStatusEnumFromJSONTyped,
    DataImportStatusEnumToJSON,
    DataImportStatusEnumToJSONTyped,
} from './DataImportStatusEnum';
import type { ImportTypeEnum } from './ImportTypeEnum';
import {
    ImportTypeEnumFromJSON,
    ImportTypeEnumFromJSONTyped,
    ImportTypeEnumToJSON,
    ImportTypeEnumToJSONTyped,
} from './ImportTypeEnum';
import type { ActionStatusEnum } from './ActionStatusEnum';
import {
    ActionStatusEnumFromJSON,
    ActionStatusEnumFromJSONTyped,
    ActionStatusEnumToJSON,
    ActionStatusEnumToJSONTyped,
} from './ActionStatusEnum';

/**
 * A data import in the list: what it imports, and which step it is in.
 * 
 * The errors and the step history are left out to keep pages light; the detail
 * has them.
 * @export
 * @interface DataImport
 */
export interface DataImport {
    /**
     * 
     * @type {string}
     * @memberof DataImport
     */
    readonly id: string;
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof DataImport
     */
    readonly importType: ImportTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof DataImport
     */
    readonly importParams: any | null;
    /**
     * 
     * @type {DataImportStatusEnum}
     * @memberof DataImport
     */
    readonly status: DataImportStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof DataImport
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof DataImport
     */
    readonly createdBy: number;
    /**
     * The current state, or None for imports from before the state machine.
     * @type {string}
     * @memberof DataImport
     */
    readonly state: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DataImport
     */
    readonly stateEnteredAt: Date | null;
    /**
     * 
     * @type {ActionStatusEnum}
     * @memberof DataImport
     */
    readonly actionStatus: ActionStatusEnum;
}



/**
 * Check if a given object implements the DataImport interface.
 */
export function instanceOfDataImport(value: object): value is DataImport {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('importType' in (value as Record<string, any>)) && !('import_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['importType'] === undefined && (value as Record<string, any>)['import_type'] === undefined)) return false;
    if ((!('importParams' in (value as Record<string, any>)) && !('import_params' in (value as Record<string, any>))) || ((value as Record<string, any>)['importParams'] === undefined && (value as Record<string, any>)['import_params'] === undefined)) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('createdBy' in (value as Record<string, any>)) && !('created_by' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdBy'] === undefined && (value as Record<string, any>)['created_by'] === undefined)) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if ((!('stateEnteredAt' in (value as Record<string, any>)) && !('state_entered_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['stateEnteredAt'] === undefined && (value as Record<string, any>)['state_entered_at'] === undefined)) return false;
    if ((!('actionStatus' in (value as Record<string, any>)) && !('action_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionStatus'] === undefined && (value as Record<string, any>)['action_status'] === undefined)) return false;
    return true;
}

export function DataImportFromJSON(json: any): DataImport {
    return DataImportFromJSONTyped(json, false);
}

export function DataImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImport {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'importType': ImportTypeEnumFromJSON(json['import_type']),
        'importParams': json['import_params'],
        'status': DataImportStatusEnumFromJSON(json['status']),
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'createdBy': json['created_by'],
        'state': json['state'],
        'stateEnteredAt': (json['state_entered_at'] == null ? null : new Date(json['state_entered_at'])),
        'actionStatus': ActionStatusEnumFromJSON(json['action_status']),
    };
}

export function DataImportToJSON(json: any): DataImport {
    return DataImportToJSONTyped(json, false);
}

export function DataImportToJSONTyped(value?: Omit<DataImport, 'id'|'importType'|'importParams'|'status'|'createdAt'|'createdBy'|'state'|'stateEnteredAt'|'actionStatus'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

